module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-toggleable-md navbar-inverse bg-darkgrey sticky-top box-shadow p-0"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/KeepNeye.png"),
      "width": "30",
      "height": "30",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "KeepNeyeNavbar"
    }
  }, [_c('ul', {
    staticClass: "navbar-nav mr-auto"
  }, [_c('li', {
    staticClass: "nav-item",
    class: {
      'nav-select': _vm.$route.name === 'Dashboard'
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/dashboard"
    }
  }, [_vm._v(_vm._s(_vm.$t('NavBar.dashboard')))])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'nav-select': _vm.$route.name === 'OrderPending' || _vm.$route.name === 'OrderCurrent'
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/OrderCurrent"
    }
  }, [_vm._v(_vm._s(_vm.$t('NavBar.orders')))])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'nav-select': _vm.$route.name === 'TransferPending' || _vm.$route.name === 'TransferCurrent'
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/TransferCurrent"
    }
  }, [_vm._v(_vm._s(_vm.$t('NavBar.transfer')))])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'nav-select': _vm.$route.name === 'Search'
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/Search"
    }
  }, [_vm._v(_vm._s(_vm.$t('NavBar.search')))])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'nav-select': _vm.$route.name === 'AddressBook'
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/AddressBook"
    }
  }, [_vm._v(_vm._s(_vm.$t('NavBar.address_book')))])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'nav-select': _vm.$route.name === 'Users'
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/Users"
    }
  }, [_vm._v(_vm._s(_vm.$t('NavBar.users')))])]), _vm._v(" "), (_vm.isAdmin) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'nav-select': _vm.$route.name === 'Logs'
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/Logs"
    }
  }, [_vm._v(_vm._s(_vm.$t('NavBar.logs')))])]) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('li', {
    staticClass: "nav-item",
    class: {
      'nav-select': _vm.$route.name === 'Reports'
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/Reports"
    }
  }, [_vm._v(_vm._s(_vm.$t('NavBar.reports')))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'nav-select': _vm.$route.name === 'Settings'
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/Settings"
    }
  }, [_vm._v(_vm._s(_vm.$t('NavBar.settings')))])])]), _vm._v(" "), _c('span', [_c('a', {
    staticClass: "nav-link navbar-text",
    attrs: {
      "id": "logout",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.signOut()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('NavBar.logout')))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggler navbar-toggler-right",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#KeepNeyeNavbar"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12bc746f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBar.vue
// module id = 828
// module chunks = 1